export function getOptionForValue(value,options){
    return options.find(option=>option.value === value)
}